import { TbFaceId, TbKey, TbList, TbMessageDots, TbUserCircle } from "react-icons/tb";
import StepItem from "./StepItem";
import { useEffect, useState } from "@wordpress/element";
import ProgressBarArticle from "../ProgressBarArticle";

export default function StepIcon({ step }) {
    return (
        <div style={{marginRight: '3rem'}} className="mt-10 mb-18">
            <div className="relative flex items-center justify-between">
                {step == 1 &&
                    <>
                        <ProgressBarArticle width={10} />
                        <StepItem color={step >= 1 && "!text-sucess-main"} icon={<TbMessageDots className="w-6" />} descricao="Contexto" />
                    </>
                }
                 {step == 2 &&
                    <>
                        <ProgressBarArticle width={40} />
                        <StepItem color={step >= 1 && "!text-sucess-main"} icon={<TbKey className="w-6" />} descricao="Palavra-chave" />
                    </>
                }
                {step == 3 &&
                    <>
                        <ProgressBarArticle width={80} />
                        <StepItem color={step >= 1 && "!text-sucess-main"} icon={<TbFaceId className="w-6" />} descricao="Referência" />
                    </>
                }
                  {step == 4 &&
                    <>
                        <ProgressBarArticle width={100} />
                        <StepItem color={step >= 1 && "!text-sucess-main"} icon={<TbList className="w-6" />} descricao="Estrutura de texto" />
                    </>
                }
            </div>
        </div>
    )
}